import { LanguageService } from './language.service';

export function languageInitializerFactory(languageService: LanguageService) {
  return () => languageService.initLanguage();
}
